import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { ReaderWorkspace } from '../components/reader/ReaderWorkspace';

export function ReaderPage() {
  const { t } = useTranslation();
  const { docId } = useParams<{ docId: string }>();

  if (!docId) {
    return (
      <div className="p-6">
        <p className="text-charcoal/60 dark:text-charcoal-light/60">
          {t('reader.selectDoc')}
        </p>
      </div>
    );
  }

  return <ReaderWorkspace docId={docId} />;
}
